import React from "react";

const FortellisTitle3 = ({ style, title }) => {
  return <div className={`fortellis-title-3 ${style}`}>{title}</div>;
};

export default FortellisTitle3;
